import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography, CircularProgress, Backdrop, Alert, Snackbar } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { DsStatusUpdate } from 'API/UserList/DsuserList';
import { useState } from 'react';

export default function StatusDialog(props) {
  const [StatusData, setStatusData] = useState('');
  const [Isloading, setIsloading] = useState(false);
  const [SuccessMsg, setSuccessMsg] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState(false);

  const handleStatus = () => {
    if(StatusData){
    DsStatusUpdate(StatusData, props.Userid, setIsloading, setSuccessMsg, setErrorMsg,setStatusData, props.handleClose, props.refunction);
    }else{
      setErrorMsg('Please select the status')
    }
  };

  return (
    <React.Fragment>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={ErrorMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setErrorMsg(false)}
      >
        <Alert onClose={() => setErrorMsg(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {ErrorMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={SuccessMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccessMsg(false)}
      >
        <Alert onClose={() => setSuccessMsg(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {SuccessMsg}
        </Alert>
      </Snackbar>
      <Dialog open={props.open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth="xs" fullWidth>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4">Status</Typography>
        </DialogTitle>
        <Box sx={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer', fontSize: '22px' }} onClick={() => props.handleClose()}>
          <IoMdClose />
        </Box>
        <DialogContent sx={{ margin: 0, paddingBlock: 0 }}>
          <Box sx={{ minWidth: 120, m: 0 }}>
            <FormControl fullWidth size="small">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={StatusData}
                onChange={(e) => setStatusData(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Status
                </MenuItem>
                <MenuItem value={'Active'}>Active</MenuItem>
                <MenuItem value={'Inactive'}>Inactive</MenuItem>
                <MenuItem value={'Blocked'}>Blocked</MenuItem>
                <MenuItem value={'Replaced'}>Replaced</MenuItem>
                <MenuItem value={'Deactivated'}>Deactivated</MenuItem>
                <MenuItem value={'To be replaced'}>To be replaced</MenuItem>
                <MenuItem value={'Terminate'}>Terminate</MenuItem>
                <MenuItem value={'Dormant'}>Dormant</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button variant="contained" color="secondary" onClick={handleStatus}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
